import React from 'react';
import Button from '@mui/material/Button';

const SpinButton = ({ onClick, spinning }) => {
    return (
        <Button variant="contained" color="primary" onClick={onClick} disabled={spinning}>
            Spin
        </Button>
    );
}

export default SpinButton;
